<div class="flex flex-col bg-[#f7f7f7]">
  <app-header></app-header>

  <main class="min-h-[calc(100vh-256px)]">
    <router-outlet></router-outlet>
  </main>

  <app-footer></app-footer>
</div>
